import React, { useState, useEffect, useRef } from 'react';
import { Form, Formik, Field } from 'formik';
// import Pagination from '@material-ui/lab/Pagination';
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import Layout from 'web/components/Layout';
import { Helmet } from "react-helmet";
import Spinner from 'web/components/Spinner';
import SearchTypeGroup from 'web/components/SearchTypeGroup';
import DropDown from "web/components/DropDown";
import Breadcrumb from 'web/components/Breadcrumb';
import YourGroups from 'web/pages/private/CommonPages/MyNetworks/YourGroups'
import CreateGroups from 'web/pages/private/CommonPages/MyNetworks/CreateGroup'
import ActivityLogs from 'web/pages/private/CommonPages/MyNetworks/ActivityLogs'
import MyNetworkIcon from 'web/assets/svg/MyNetworkIcon'
import InviteIcon from 'web/assets/svg/InviteIcon'
import DP from 'web/assets/images/userPicDummy.jpeg'
import NotificationBellIcon from 'web/assets/svg/NotificationBellIcon'
import SearchResult from 'web/pages/private/CommonPages/MyNetworks/SearchResult'
import ManageInvitations from 'web/pages/private/CommonPages/MyNetworks/ManageInvitations'
import Notification from 'web/pages/private/CommonPages/MyNetworks/Notification'
import { notificationApiV2, notificationMarkReadApiV2 } from 'redux/actions/notification';
import InviteMember from 'web/pages/private/CommonPages/MyNetworks/InviteMember'
import ManageInvitationsIcon from 'web/assets/svg/ManageInvitations'
import ConnectionIcon from 'web/assets/svg/ConnectionIcon'
import GroupsIcon from 'web/assets/svg/GroupsIcon'
import ProfileImageEditIcon from 'web/assets/svg/ProfileImageEditIcon'
import InviteLogIcon from 'web/assets/images/inviteLogIcon.png'
import AlertModal from 'web/components/AlertModal';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { networkAll, getNetwork, addNetworkEmailAddress, requestToJoinGroup, searchGroupApi, getNetworkRequest, deleteGroupApi, deleteNetwork, makeAdminApi, exitFromGroupApi, removedFromGroupApi } from 'redux/actions/myNetwork';
import { notificationClearApiV2 } from 'redux/actions/notification';
import { getProfileDetails } from 'redux/actions/profile'
import {
  Container,
  Wrapper,
  SectionWrapper,
  ButtonGroup,
  ProFileWrapper,
  HeaderSection,
  SearchSection,
  LinksSection,
  ProfileDpsection,
  DropDownDiv
} from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";
import ProfilePicture from 'web/components/ProfilePicture'
import { fetchLanguageContentNew } from 'redux/actions/language';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const MyNetworks = (props) => {
  const token = localStorage.getItem("token");
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const urlObject = useSelector((state) => state.urlParameters.community);
  const typeahead = useRef(null);
  const [activeIndex, setActiveIndex] = React.useState('groups');
  const dispatch = useDispatch();
  let history = useHistory();

  const [searchDropDown, setSearchDropDown] = useState("GROUP");
  const filterArr = [
    {
      id: "0",
      label: "Group",
      value: "GROUP",
    },
    {
      id: "1",
      label: "Member",
      value: "MEMBER",
    },
  ];

  const [networkResponse, setNetworkResponse] = useState([]);
  const [groupListResponse, setGroupListResponse] = useState(undefined);
  const [groupNameState, setGroupNameState] = useState(undefined);
  const [alertTypeState, setAlertTypeState] = useState();
  const [memberToInviteState, setMemberToInviteState] = useState(undefined);
  const INITIAL_VALUES = { profileImg: '', };

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.My_Community_Page) setPageLanguageContents(languageContentNew.My_Community_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    const { location } = props;
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.get("email")) {
      if (queryParams.get("selectedTab") === 'invite') {
        setActiveIndex('manageInvitations')
      } else if (queryParams.get("email")) {
        if (localStorage.getItem('myCommunityNotification')) {
          localStorage.setItem('saveUrl', '');
        } else {
          localStorage.setItem('saveUrl', queryParams.get("email"));
        }
        setActiveIndex('manageInvitations')
      } else {
        setActiveIndex('groups')
      }
    }
    else {
      if (urlObject) {
        if (urlObject.selectedTab === 'invite' || queryParams.selectedTab === 'invite') {
          setActiveIndex('manageInvitations')
        }
        else if (urlObject.email || queryParams.email) {
          if (localStorage.getItem('myCommunityNotification')) {
            localStorage.setItem('saveUrl', '');
          } else {
            localStorage.setItem('saveUrl', urlObject.email);
          }
          setActiveIndex('manageInvitations')
        } else {
          setActiveIndex('groups')
        }
      } else {
        if (queryParams.selectedTab === 'invite') {
          setActiveIndex('manageInvitations')
        }
      }
    }

    if (token) {
      getProfileImage()
      fetchMyAPI()
      getNetworkApi()
      getNetworkRequests()
      notificationApiFun()
    } else {
      history.push('/sign-in')
      window.location.reload(false);
    }
  }, [])

  const [notificationCount, setNotificationCount] = useState();
  const [notificationResponse, setNotificationResponse] = useState();
  const [notificationPageDataInfo, setNoficationPageDataInfo] = useState('');

  const notificationApiFun = async (pageNo) => {
    let data = {
      size: 20,
      number: pageNo ? pageNo - 1 : 0,
      actionType: ["NETWORK"]
    }
    let response = await dispatch(notificationApiV2(token, data));
    if (response.success) {
      setNotificationCount(response.data?.myCommunityNotificationsCount)
      if (pageNo === 1) setNoficationPageDataInfo('pageResetToOne')
      else setNoficationPageDataInfo('')
      if (pageNo && pageNo > 1) setNotificationResponse(prevData => [...prevData, ...response.data?.myCommunityNotifications])
      else setNotificationResponse(response.data?.myCommunityNotifications)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else if (response?.data?.error?.message === 'No results.') {
        setNoficationPageDataInfo('endOfResults')
      }
    }
  };

  const notificationClearAllFunction = async () => {
    let data = {
      notificationId: null,
      actionType: "NETWORK",
      requestType: null
    }
    let response = await dispatch(notificationClearApiV2(data, token));
    if (response.success) {
      notificationApiFun()
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  const notificationMarkReadFunction = async (id, items) => {
    let response;
    let data = {
      notificationId: items.notificationId,
    }
    response = await dispatch(notificationMarkReadApiV2(data, token));
    if (response.success) {
      notificationApiFun()
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  }

  let [profileImageResponse, setProfileImageResponse] = useState()
  const getProfileImage = async () => {
    let data = { authId: localStorage.getItem('authId') }
    let response = await dispatch(getProfileDetails(token, data));
    if (response.userName) {
      setProfileImageResponse(response)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  };
  const getNetworkApi = async () => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let response = await dispatch(getNetwork(token));
      if (response.status === "SUCCESS") {
        if (response.payload) {
          setGroupListResponse(response.payload)
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          if (response.message === "Full authentication is required to access this resource") {
            history.push('/sign-in')
            window.location.reload(false);
          } else if (response.message === "") {
            history.push('/sign-in')
            window.location.reload(false);
          } else {
            setModalContent(response.message);
            setModalLink("");
            toggleModal();
          }
        }
      }
    }
  };

  const [searchGrpMemText, setSearchGrpMemText] = useState()
  const [searchState, setSearchState] = useState([]);
  const [searchTotalElementsState, setSearchTotalElementsState] = useState()
  const [searchPagePostionInfo, setSearchPagePositionInfo] = useState('')
  const searchGroupApiFun = async (title, pageNo, searchGrpMem) => {
    let searchCriteria = searchGrpMem || searchDropDown
    let postData = {
      size: 20,
      number: (pageNo - 1) ?? 0,
      sort: "DESC",
      searchBy: title || "",
    };
    let url = (searchCriteria === 'GROUP') ? 'rfp/v2/search/community_group' : 'user/v2/search/community_members'
    let response = await dispatch(searchGroupApi(url, postData, token));
    if (response.success) {
      if (pageNo === 1) setSearchPagePositionInfo('pageResetToOne')
      else setSearchPagePositionInfo('')
      if (response.data?.totalElements > 0) {
        setActiveIndex('searchResult')
        setSearchTotalElementsState(response.data?.totalElements)
        if (pageNo > 1) setSearchState(prevData => [...prevData, ...response.data?.communitySearch])
        else setSearchState(response.data?.communitySearch)
      } else {
        setSearchState([])
        setSearchTotalElementsState()
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else if (response.statusCode === 409) {
        if (pageNo === 1) {
          setSearchState([])
          setSearchTotalElementsState()
        }
        setSearchPagePositionInfo('endOfResults')
      }
    }
  };

  const makeAdminApiFun = async (item, authId) => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let data = {
        networkId: item.id,
      }
      let response = await dispatch(makeAdminApi(authId, data, token));
      if (response.status === "SUCCESS") {
        fetchMyAPI()
        getNetworkApi()
        getNetworkRequests()
        setAlertTypeState("createGroup")
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const [deleteResponse, setDeleteResponse] = useState(undefined);

  const deleteGroupApiFun = async (item, authId) => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let data = {
        networkId: item.id,
      }
      let response = await dispatch(deleteGroupApi(data, token));
      if (response.status === "SUCCESS") {
        fetchMyAPI()
        getNetworkApi()
        getNetworkRequests()
        setAlertTypeState("createGroup")
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const removeGroupApiFun = async (item, authId) => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let data = {
        networkId: item.id,
      }
      let response = await dispatch(removedFromGroupApi(authId, data, token));
      if (response.status === "SUCCESS") {
        if (response.payload) {
          setDeleteResponse(response.payload)
        }
        fetchMyAPI()
        getNetworkApi()
        getNetworkRequests()

        setAlertTypeState("createGroup")
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const [exitResponse, setExitResponse] = useState(undefined);

  const exitGroupApiFun = async (item, authId) => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let data = {
        networkId: item.id,
      }
      let response = await dispatch(exitFromGroupApi(data, token));
      if (response.status === "SUCCESS") {
        if (response.payload) {
          setExitResponse(response.payload)
        }
        fetchMyAPI()
        getNetworkApi()
        getNetworkRequests()
        setAlertTypeState("createGroup")
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const fetchMyAPI = async () => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let response = await dispatch(networkAll(token));
      if (response.status === "SUCCESS") {
        if (response.payload) {
          let arr = []
          if (response.payload.length !== 0) {
            for (let i = 0; i < response.payload.length; i++) {
              const selectGroupArr =
              {
                label: response.payload[i].networkName,
                value: response.payload[i].id,
                id: response.payload[i].id,
                payload: response.payload[i].payload,
              }
              arr.push(selectGroupArr)
              setNetworkResponse(selectGroupArr)
              if (i === response.payload.length - 1) {
                setNetworkResponse(arr)
              }
            }
          } else {
            setNetworkResponse([])
          }

        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        }
      }
    }
  };
  const [networkRequests, setNetworkRequests] = useState(undefined);

  const getNetworkRequests = async () => {
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let response = await dispatch(getNetworkRequest(token));
      if (response.status === 'SUCCESS') {
        if (response.payload.length !== 0) {
          for (let i = 0; i < response.payload.length; i++)
            if (response.payload.owner === true) {
            } else if (response.payload.owner === false) {
            }

          setNetworkRequests(response.payload);
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }
  const sendRequestInviteApi = async (networkId) => {
    let data = {
      emails: [localStorage.getItem('email')],
      networkId: networkId,
      comment: ''
    }
    if (token === null) {
      history.push('/sign-in');
      window.location.reload(false);
    } else {
      let inviteResponse = await dispatch(requestToJoinGroup(data, token));
      if (inviteResponse.status === "SUCCESS") {
        setActiveIndex('groups')
        getNetworkApi()
        setModalContent(inviteResponse.message);
        setModalLink('');
        toggleModal();
      } else {
        if (inviteResponse.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(inviteResponse.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  return (
    <>
      <Helmet title="Create Private User Groups. Collaborate on Bids and Offers" >
        <meta name="description"
          content="Create private user groups to conduct business with your current partners and suppliers, broadcast your pallet wants and needs, or to collaborate on bids or offers." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/my-community" />
      </Helmet>
      <Layout pageType="myCommunity" topBarViewMobile={"hide"}>
        {(loaderVisible && activeIndex !== 'searchResult') && <Spinner />}
        <Container>
          <Wrapper>
            <SectionWrapper>
              <ProFileWrapper>
                <Formik
                  initialValues={INITIAL_VALUES}
                  onSubmit={(values) => {
                  }}>
                  {(props) => {
                    const {
                      isValid,
                      dirty,
                      values,
                      errors,
                      touched,
                      setFieldValue,
                    } = props;
                    return (
                      <>
                        <Form>
                          <ProfileDpsection>
                            <ProfilePicture
                              name="profileImgCommunity"
                              props={props}
                              profileImagePath={profileImageResponse?.profileImage}
                              Picture={DP}
                              ProfileName={profileImageResponse?.userName}
                              CompanyName=""
                              pageType=""
                            />
                            <div className='icon-section' onClick={() => {
                              history.push('/manage-account')
                            }}>
                              <ProfileImageEditIcon className='edit-icon' />
                            </div>
                          </ProfileDpsection>
                        </Form>
                      </>
                    );
                  }}
                </Formik >
                <ButtonGroup>
                  <li onClick={() => {
                    setGroupNameState(undefined)
                    setActiveIndex('inviteMember')
                  }}>
                    <ConnectionIcon />{pageLanguageContents?.MyCommunity[0]?.Connections}
                  </li>
                  <li onClick={() => {
                    setActiveIndex('groups')
                  }}><GroupsIcon />{pageLanguageContents?.MyCommunity[1]?.Groups}</li>
                  <li onClick={() => {
                    setActiveIndex('manageInvitations')
                  }}><ManageInvitationsIcon />{pageLanguageContents?.MyCommunity[2]?.ManageInvitations}</li>
                  <li onClick={() => {
                    setActiveIndex('logs')
                  }}><img src={InviteLogIcon} alt='Technology' />{pageLanguageContents?.MyCommunity[9]?.Logs}</li>
                </ButtonGroup>
              </ProFileWrapper>
              <div>
                <HeaderSection>
                  <DropDownDiv>
                    <DropDown
                      name="dropDown"
                      data={filterArr}
                      searchDropDown={searchDropDown}
                      placeholder="Filter"
                      onChangeHandler={(event) => {
                        setSearchDropDown(event.value);
                        setSearchGrpMemText()
                        searchGroupApiFun('', 1, event.value)
                      }}
                    />
                  </DropDownDiv>

                  <SearchSection>
                    <SearchTypeGroup
                      placeholder={pageLanguageContents?.MyCommunity[3]?.MyCommunitySearch}
                      focusOnShow={false}
                      typeahead={typeahead}
                      filterBy="title"
                      defaulTitle={searchGrpMemText || ''}
                      pageType={''}
                      containerStyle="makeSearch"
                      color="#fff"
                      searchDropDown={searchDropDown}
                      callBack={(title) => {
                        if (title === '') {
                          setActiveIndex('groups')
                        } else {
                          setActiveIndex('searchResult')
                        }
                        setSearchGrpMemText(title)
                        searchGroupApiFun(title, 1)
                      }}
                    />

                  </SearchSection>
                  <LinksSection>
                    <li onClick={() => {
                      setActiveIndex('groups')
                    }}><MyNetworkIcon />{pageLanguageContents?.MyCommunity[4]?.MyNetwork}</li>
                    <li onClick={() => {
                      setGroupNameState(undefined)
                      setActiveIndex('inviteMember')
                    }}><InviteIcon />{pageLanguageContents?.MyCommunity[5]?.Invite}</li>
                    <li onClick={() => {
                      setActiveIndex('notifications')
                      setNotificationResponse()
                      setNoficationPageDataInfo('')
                      notificationApiFun(1)
                    }}><NotificationBellIcon />
                      <p className="notification">
                        {notificationCount && notificationCount}
                      </p>
                      {pageLanguageContents?.MyCommunity[6]?.Notifications}</li>
                    <li onClick={() => {
                      setActiveIndex('createGroups')
                    }}><button>{pageLanguageContents?.MyCommunity[7]?.CreateGroup}</button></li>
                  </LinksSection>
                </HeaderSection>

                {activeIndex === 'groups' && groupListResponse && <YourGroups groupListResponse={groupListResponse} pageLanguageContents={pageLanguageContents}
                  closeIconCallBack={(val) => {
                    setActiveIndex('groups')
                    if (val === "groupImgUpdate") {
                      fetchMyAPI()
                      getNetworkApi()
                      getNetworkRequests()
                    }
                  }}
                  inviteCallBack={(groupName, item, authId) => {
                    if (groupName === 'makeAdmin') {
                      makeAdminApiFun(item, authId)
                    } else if (groupName === "deleteGroup") {
                      deleteGroupApiFun(item, authId)
                    } else if (groupName === 'remove') {
                      removeGroupApiFun(item, authId)
                    } else if (groupName === 'exit') {
                      exitGroupApiFun(item, authId)
                    }
                    else {
                      setGroupNameState(item)
                      setActiveIndex('inviteMember')
                    }
                  }}
                />}
                {activeIndex === 'createGroups' && <CreateGroups pageLanguageContents={pageLanguageContents}
                  closeIconCallBack={() => {
                    setActiveIndex('groups')
                    fetchMyAPI()
                    getNetworkApi()
                    getNetworkRequests()
                  }}
                />}
                {activeIndex === 'inviteMember' && <InviteMember pageLanguageContents={pageLanguageContents} networkResponse={networkResponse} memberToInviteState={memberToInviteState} groupNameState={groupNameState} closeIconCallBack={() => {
                  setActiveIndex('groups')
                  fetchMyAPI()
                  getNetworkApi()
                  getNetworkRequests()
                  setMemberToInviteState()
                }}
                  clearmemberToInviteState={() => {
                    setMemberToInviteState()
                  }}
                />}
                {activeIndex === 'searchResult' &&
                  <SearchResult
                    pageLanguageContents={pageLanguageContents}
                    searchTotalElementsState={searchTotalElementsState}
                    searchPagePostionInfo={searchPagePostionInfo}
                    searchState={searchState}
                    isMemberOrGroup={searchDropDown}
                    searchGroupApiFunCallBack={(pageNo) => searchGroupApiFun(searchGrpMemText, pageNo)}
                    closeIconCallBack={(type, selectedItem) => {
                      if (type === "requestToJoin") {
                        sendRequestInviteApi(selectedItem.networkId)
                        setMemberToInviteState()
                      } else if (type === "InviteMember") {
                        setGroupNameState(undefined)
                        setMemberToInviteState(selectedItem)
                        setActiveIndex('inviteMember')
                      } else {
                        setActiveIndex('groups')
                      }
                    }}
                    inviteCallBack={(item) => {
                      setGroupNameState(item)
                      setActiveIndex('inviteMember')
                    }}
                  />}
                {activeIndex === 'manageInvitations' && <ManageInvitations pageLanguageContents={pageLanguageContents} networkRequests={networkRequests} closeIconCallBack={(val) => {
                  if (val === "Back" || val === 'Accept') {
                    setActiveIndex('groups')
                  }
                  fetchMyAPI()
                  getNetworkApi()
                  getNetworkRequests()
                }} />}
                {(activeIndex === 'notifications' && notificationResponse) &&
                  <Notification
                    pageLanguageContents={pageLanguageContents}
                    notificationResponse={notificationResponse}
                    notificationPageDataInfo={notificationPageDataInfo}
                    fetchNotificationsCallback={notificationApiFun}
                    closeIconCallBack={(val, id, items) => {
                      if (val === "Click") {
                        notificationMarkReadFunction(id, items)
                        setActiveIndex('manageInvitations')
                      } else {
                        if (val === "clearAll") {
                          notificationClearAllFunction()
                        } else {
                          setActiveIndex('groups')
                        }
                      }
                      fetchMyAPI()
                      getNetworkApi()
                      getNetworkRequests()
                    }} />}
                {activeIndex === 'logs' && <ActivityLogs pageLanguageContents={pageLanguageContents}
                  closeIconCallBack={() => {
                    setActiveIndex('groups')
                    fetchMyAPI()
                    getNetworkApi()
                    getNetworkRequests()
                  }}
                />}
              </div>
            </SectionWrapper>
          </Wrapper>
        </Container>

      </Layout>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
        alertType={alertTypeState}
        callBackAlert={(val) => {
          if (val === "createGroup")
            setActiveIndex('groups')
        }}
      />
    </>
  );
}

export default MyNetworks;